// extracted by mini-css-extract-plugin
export default {"buttons":"Card_buttons__+Zdo+","card":"Card_card__qHyQc","content":"Card_content__U6CeK","header":"Card_header__BAs-W","main":"Card_main__79yLS","title":"Card_title__d9WfY"};